import { TimesheetMinimalPeriodsSource } from 'app/constants/configuration/timesheetMinimalPeriodsSource'

export const getTimesheetMinimalPeriodsSource = (
  type: number,
): TimesheetMinimalPeriodsSource => {
  let timesheetMinimalPeriodsSource = TimesheetMinimalPeriodsSource.MixMode

  switch (type) {
    case 1:
      timesheetMinimalPeriodsSource = TimesheetMinimalPeriodsSource.Trip
      break
    case 2:
      timesheetMinimalPeriodsSource = TimesheetMinimalPeriodsSource.Gps
      break
  }

  return timesheetMinimalPeriodsSource
}
